<template>
  <div>
    <template v-if="!$vuetify.breakpoint.smAndDown">
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            class="white--text mb-2 mr-3"
            v-bind="attrs"
            v-on="on"
            color="blue-grey"
            :loading="isLoading"
            :disabled="isLoading"
          >
            Actions
            <v-icon right dark>mdi-tray-arrow-up</v-icon>
          </v-btn>
        </template>

        <v-list class="pa-0">
          <v-list-item
            v-for="(action, index) in actions"
            :key="index"
            link
            @click="handleAction(action)"
          >
            <v-list-item-title v-text="action"></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn v-if="!isAuditorRole" color="#2b3990" dark class="mb-2" @click="handleShowAdd">
        <v-icon left>add</v-icon>
        {{ btnTitle }}
      </v-btn>
    </template>
  </div>
</template>

<script>
/*eslint-disable*/
import reports from "@/mixins/reports";
import download from "downloadjs";

export default {
  mixins: [reports],
  props: {
    actions: {
      type: Array,
      required: true,
      default: () => [],
    },
    btnTitle: {
      type: String,
      default: "Add",
    },
    fileName: {
      type: String,
    },
    navigateTo: {
      type: Object,
    },
    payload: {
      type: Object,
    },
    isAuditorRole: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async handleAction(action) {
      try {
        this.isLoading = true;
        if (action === "Print") {
          await this.getReport(this.payload);
        } else {
          const response = await this.generateDynamicReport(this.payload);
          download(response.data, this.payload.fileName, "application/pdf");
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },

    onSelectAction(action) {
      switch (action) {
        case "add":
          this.$router.push(this.navigateTo);
          break;
        case "print":
          this.handleAction("Print");
          break;
        case "download":
          this.handleAction("Download");
          break;
        default:
          console.error(`Unknown action: ${action}`);
      }
    },

    handleShowAdd() {
      this.$router.push(this.navigateTo);
    },
  },
};
</script>
